export enum NewsletterListIds {
	Hat = 430,
	Homepage = 434,
	Talks = 426,
	Primary = 432,
	Editions = 436,
	Publishing = 88,
	Nft = 442,
	WhereTheLandMeetsTheSea = 602,
	Merch = 604,
	Exhibitions = 676,
	RegisterInterest = 915,
	News = 277,
	Blog = 987,
	Digital = 989,
	Fab = 992,
	Shop = 1524,
}

export enum NewsletterTestListIds {
	Hat = 994,
	Homepage = 495,
	Talks = 491,
	Primary = 492,
	Editions = 490,
	Publishing = 497,
	Nft = 489,
	WhereTheLandMeetsTheSea = 601,
	Merch = 605,
	Exhibitions = 677,
	RegisterInterest = 916,
	News = 496,
	Blog = 493,
	Digital = 990,
	Fab = 993,
	Shop = 1525,
}
